import { Box, Typography } from '@mui/material';

import { FORTA_WHITE, FORTA_SUCCESS } from '../../utils/colors';

interface IFHChipProps {
  bgColor?: string;
  color?: string;
  sx?: any;
  content?: string | number;
  fontSize?: number;
  noWrap?: boolean;
  onClick?: (id?: string | number) => void;
  contentRenderer?: () => JSX.Element;
}

const FHChip = (props: IFHChipProps) => {
  const {
    bgColor = FORTA_SUCCESS,
    color = FORTA_WHITE,
    sx = {},
    fontSize = 16,
    content = '',
    noWrap = false,
    onClick,
    contentRenderer,
  } = props;

  return (
    <Box onClick={() => (onClick ? onClick(content) : {})} sx={{ display: 'inline-block' }}>
      {contentRenderer ? (
        contentRenderer()
      ) : (
        <Typography
          sx={{
            py: 0.5,
            px: 2,
            borderRadius: 4,
            backgroundColor: bgColor,
            '&:hover': {
              cursor: onClick ? 'pointer' : 'default',
            },
            display: 'inline-block',
            ...sx,
          }}
          color={color}
          noWrap={noWrap}
          fontSize={fontSize}
        >
          {content}
        </Typography>
      )}
    </Box>
  );
};

export default FHChip;
